import React from 'react'
import { SecondaryButton } from '@softura/fluentuipackage'
import './SecondaryButton.scss'

interface IProps {
  iconProps?:any,
  menuIconProps?:any,
  text?: string,
  onClick?: any,
  className?: string | number,
  imgSrc?: any,
  children?: any,
  btnRef?: any,
  dataAttribute?: any
}
const SecondaryButtonContainer = ({
  text = '',
  className = '',
  imgSrc = null,
  onClick,
  menuIconProps = null,
  iconProps = null,
  children = null,
  btnRef,
  dataAttribute = ""
}:IProps) => {
  return (<>
      <SecondaryButton
          text={text}
          className={`secondary-btn ${className}`}
          imgSrc={imgSrc}
          onClick={onClick}
          iconProps={iconProps}
          menuIconProps={menuIconProps}
          componentRef={btnRef}
          data-attribute={dataAttribute}>
        {children}
      </SecondaryButton>
    </>
  )
}


export default SecondaryButtonContainer
